import { useState } from "react";
import MatriHeader from "../components/MatriHeader";
import MatrimonyHomeHero from "../components/MatrimonyHomeHero";
import { Sidebar } from "../components/sidebar";
import { DashboardContent } from "../components/dashboard-content";
import { ProfileContent } from "../components/profile-content";
import { ProfileListsContent } from "../components/profile-lists-content";
import { RequestsSentContent } from "../components/requests-sent-content";
import { ProfileListingContent } from "../components/profile-listing-content";
import Footer from "../components/Footer";

const sectionComponents = {
  dashboard: DashboardContent,
  profile: ProfileContent,
  "profile-lists": ProfileListsContent,
  "requests-sent": RequestsSentContent,
  "profile-listing": ProfileListingContent,
};

export default function MatrimonyDashboard() {
  const [activeSection, setActiveSection] = useState("dashboard");

  const handleSectionChange = (section) => {
    setActiveSection(section);
  };

  const Section = sectionComponents[activeSection] || DashboardContent;

  return (
    <div className="flex flex-col min-h-screen bg-gray-50">
      <MatriHeader />
      <MatrimonyHomeHero />

      <div className="flex flex-1">
        <Sidebar activeSection={activeSection} onSectionChange={handleSectionChange} />
        <div className="flex-grow p-4 overflow-auto">
          {/* render component and pass onSectionChange so child can switch sections */}
          <Section onSectionChange={handleSectionChange} />
        </div>
      </div>

      <Footer />
    </div>
  );
}
